export const disableForOptions = [
  { value: 'disable_returns', label: 'Devoluciones' },
  { value: 'disable_exchanges', label: 'Cambios' },
]
